import { Component, Input, OnInit, Type, ViewChild, ViewContainerRef } from '@angular/core';
import { LanguageSelectorComponent } from '../common/language-selector/language-selector.component';
import { CustomerContact } from 'src/app/classes/customer-contact';
import * as fa from '@fortawesome/free-solid-svg-icons';
import locales from 'src/app/constants/locales';
import { Organization } from 'src/app/classes/organization';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CustomerService } from 'src/app/services/customer.service';
import { SettingsService } from 'src/app/services/settings.service';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-require',
  templateUrl: './require.component.html',
  styleUrls: ['./require.component.scss'],
})
export class RequireComponent  implements OnInit {
  @ViewChild('modalOutlet', { read: ViewContainerRef, static: true }) modalOutlet!: ViewContainerRef;
  @Input() childComponent!: Type<any>; // you pass this in when opening

  contact = new CustomerContact()
  fa = fa
  locales = locales
  locale = $localize.locale
  organization!: Organization

  constructor(public activeModal: NgbActiveModal,
    private authService: AuthService,
    private customerService: CustomerService,
    private modalService: NgbModal,
    private settingsService: SettingsService
  ) { }

  ngOnInit() {
    this.settingsService.organizationPublic().subscribe(organization => {
      this.organization = organization
    })
    
    this.customerService.current().subscribe(contact => {
      this.contact = contact as CustomerContact
    })
  }

  ngAfterViewInit() {
    if (this.childComponent) {
      this.modalOutlet.clear();
      this.modalOutlet.createComponent(this.childComponent);
    }
  }

  languageSelector() {
    const modal = this.modalService.open(LanguageSelectorComponent, { centered: true, size: 'md' })
  }
}
